import {AxiosConfig} from "./AxiosConfig/AxiosConfig";
import {ITopic} from "../Interfaces/Topic";

const getAllTopics = async (): Promise<Array<ITopic>> => {
    return new Promise<Array<ITopic>>((resolve) => {
        return AxiosConfig.instance.get("/topics").then(res => {
            const topics: Array<ITopic> = res.data;
            return resolve(topics);
        }).catch(error => {
            console.error(error);
            resolve(new Array<ITopic>());
        });
    });
}

const getTopic = async (id: string): Promise<ITopic> => {
    return new Promise<ITopic>((resolve, reject) => {
        return AxiosConfig.instance.get(`/topics/${id}`).then(res => {
            return resolve(res.data);
        }).catch(error => {
            console.error(error);
            reject("Can't get topic with id : " + id);
        });
    });
}

const deleteTopic = async (topicId: string): Promise<boolean> => {
    return new Promise<boolean>((resolve) => {
        return AxiosConfig.instance.delete(`/topics/${topicId}`).then(() => {
            return resolve(true);
        }).catch(error => {
            console.error(error);
            resolve(false);
        });
    });
}

const deleteTopicTranslation = async (topicId: string, translationId: string): Promise<boolean> => {
    return new Promise<boolean>((resolve) => {
        return AxiosConfig.instance.delete(`/topics/${topicId}/translation/${translationId}`).then(() => {
            return resolve(true);
        }).catch(error => {
            console.error(error);
            resolve(false);
        });
    });
}

const addTopic = async (topic: ITopic): Promise<ITopic> => {
    return new Promise<ITopic>((resolve, reject) => {
        return AxiosConfig.instance.post(`/topics`, topic).then(res => {
            const data: { inserted: Array<ITopic> } = res.data;
            const topic = data.inserted[0];
            return resolve(topic);
        }).catch(error => {
            console.error(error);
            reject("Can't add topic");
        });
    });
}

const updateTopic = async (topic: ITopic): Promise<ITopic> => {
    return new Promise<ITopic>((resolve, reject) => {
        return AxiosConfig.instance.put(`/topics/${topic.id}`, topic).then(res => {
            return resolve(res.data);
        }).catch(error => {
            console.error(error);
            reject("Can't update topic");
        });
    });
}

const TopicApi = {
    getAllTopics,
    deleteTopic,
    getTopic,
    deleteTopicTranslation,
    addTopic,
    updateTopic,
}

export default TopicApi;